import { ActionTypes } from "../constants/actionTypes";

const initialState = {
  genericLoading: false,
  reconLoading: false,
};

export default function loaderReducer(state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case ActionTypes.UPDATE_LOADER:
      return {
        ...state,
        ...payload,
      };
    default:
      return state;
  }
}
